export enum DataDeletionRequestLevel {
  SPECIFIC_PATIENTS = 'SPECIFIC_PATIENTS',
  SPECIFIC_PROFILES = 'SPECIFIC_PROFILES',
  ENTIRE_ORGANIZATION = 'ENTIRE_ORGANIZATION',
}

export interface SelectedPatient {
  id: string;
  firstName: string;
  lastName: string;
  dateOfBirth: string;
  profileName: string;
  profileColor?: string;
}

export interface SelectedProfile {
  id: string;
  name: string;
  patientCount: number;
  color?: string;
}

export interface DataDeletionFormState {
  deletionType: DataDeletionRequestLevel;
  deletionDate: Date | undefined;
  selectedPatients: SelectedPatient[];
  selectedProfiles: SelectedProfile[];
  isExportData: boolean;
}
